<template>
  <a-drawer
    :visible="visible"
    placement="right"
    title="字段查看"
    width="45%"
    @close="open(false)"
  >
    <div>
      <div class="titleDiv">
        <div class="title">基础信息</div>
      </div>
      <a-row>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段名称</span>
          <span>{{ model.name }}</span>
        </a-col>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段简称</span>
          <span>{{ model.nameDesc }}</span>
        </a-col>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段状态</span>
          <span>{{ model.status === 1 ? '在用' : '禁用' }}</span>
        </a-col>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段ID</span>
          <span>{{ model.id }}</span>
        </a-col>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段类型</span>
          <span>{{ model.valueType === 1 ? '填空' : '单选' }}</span>
        </a-col>
        <a-col :span="12" class="formCol">
          <span class="formTitle">字段长度限制</span>
          <span>{{ model.lengthMax }}</span>
        </a-col>
        <a-col :span="24" class="formCol between">
          <span class="formTitle">单选要求</span>
          <span class="content">{{ model.valueOptions }}</span>
        </a-col>
        <a-col :span="24" class="formCol between">
          <span class="formTitle">备注</span>
          <span class="content">{{ model.remark }}</span>
        </a-col>
      </a-row>
    </div>
    <div>
      <div class="titleDiv">
        <div class="title">已关联参数信息</div>
      </div>
      <a-table
        :columns="tableData.columns"
        :data-source="tableData.data"
        :pagination="tableData.pagination"
        :rowKey="record => record.id"
        @change="handleTableChange">
      </a-table>
    </div>
  </a-drawer>
</template>

<script>
import { getDetail, getDetailTable } from '@/api/fieldManage'

export default {
  name: 'ViewModules',
  data () {
    return {
      model: {},
      visible: false,
      tableData: {
        columns: [
          {
            title: '已关联设备类型',
            dataIndex: 'equipmentTypeName'
          },
          {
            title: '所属参数',
            dataIndex: 'paramTypeName'
          },
          {
            title: '是否必填',
            dataIndex: 'requiredState',
            customRender: (text, record) => {
              return record.requiredState ? '是' : '否'
            }
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0
          // pageSizeOptions: ['10', '20', '30', '40'],
          // showSizeChanger: true,
          // showQuickJumper: true
        }
      },
      tableHeight: ''
    }
  },
  created () {

  },
  methods: {
    setModel (model) {
      this.model = model
      this.getTableData()
    },
    open (visible) {
      this.visible = visible
    },
    // 获取详情数据
    getTableData () {
      getDetail({ id: this.model.id }).then(res => {
        if (res.status === 0) {
          this.tableData.data = res.data.fieldInfoList
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
      // 获取表格数据
      const data = {
        id: this.model.id,
        pageNum: this.tableData.pagination.pageNum,
        pageSize: this.tableData.pagination.pageSize
      }
      getDetailTable(data).then(res => {
        if (res.status === 0) {
          this.tableData.data = res.data.list
          this.tableData.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 切换页码
    handleTableChange (pagination) {
      this.tableData.pagination.pageNum = pagination.current
      this.tableData.pagination.pageSize = pagination.pageSize
      // this.getTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
  }
}
.formCol {
  margin-bottom: 20px;
  .formTitle {
    color: #B3B3B3;
    margin-right: 12px;
    display: inline-block;
    width: 6em;
    text-align: right;
  }
}
.between {
  display: flex;
  flex-direction: row;
  .content {
    display: inline-block;
    width: calc(100% - 6em - 12px);
  }
}
</style>
